//1.导入Vue和VueRouter的包
import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/views/index/home.vue'
import detail from '@/views/detail/detail.vue'
//2.调用Vue.use()函数，把VueRouter安装为Vue的插件
Vue.use(VueRouter)
const routes = [
    {
        path: '*',
        redirect: '/IndexPage'//重定向
    },
    {
        path: '/IndexPage',
        name: 'IndexPage',
        //组件已经导入，直接写组件名
        component: index,//路由名字
        children: [
            //子路由
        ]
    },
    {
        path: '/detail',
        name: 'detail',
        //组件已经导入，直接写组件名
        component: detail,//路由名字
        children: [
            //子路由
        ]
    },
    
]
//3.创建路由的实例对象
const router = new VueRouter({
    routes
})
//4.向外共享路由的实例对象
export default router